/** Wizard step identifiers, matching `OnboardingStep` ids in the backend domain. */
export const STEP = Object.freeze({
  /** Welcome screen shown before the partner starts; has no backend counterpart. */
  greeting: 3,
  firmKeyDetails: 4,
  firmAddress: 5,
  addEmployees: 6,
  otherSoftwaresUsed: 7,
  uploadFirmLogo: 8,
  invoiceInformation: 9,
  review: 10,
});

/**
 * Resolves the step to navigate back to.
 * `uploadFirmLogo` is hidden from the wizard, so it is skipped in the reverse
 * direction too — otherwise the user would land on a blank, unrenderable step.
 *
 * @param {number} currentStep - The step the user is currently on.
 * @returns {number} The step to navigate back to.
 */
export const getPreviousStep = (currentStep) => (
  currentStep === STEP.invoiceInformation
    ? STEP.otherSoftwaresUsed
    : currentStep - 1
);

/**
 * Resolves the step to open the wizard on, based on the step the backend reports.
 *
 * - `firmKeyDetails` is the first partner step, and the backend sets it as soon as the *sales*
 *   onboarding is submitted. It therefore means "the partner has not started yet", so the wizard
 *   opens on the greeting screen that precedes it rather than dropping the user into a form.
 * - `uploadFirmLogo` is hidden from the wizard. The backend reports it once `otherSoftwaresUsed`
 *   is completed, and it is also the stored step for partners who were mid-flow before the step
 *   was hidden. Both cases resume on `invoiceInformation`.
 *
 * @param {number} currentStep - The onboarding step reported by the backend.
 * @returns {number} The step the wizard should open on.
 */
export const getInitialStep = (currentStep) => {
  if (currentStep === STEP.firmKeyDetails) {
    return STEP.greeting;
  }

  return currentStep === STEP.uploadFirmLogo ? STEP.invoiceInformation : currentStep;
};
